import {gsap} from 'gsap';

export class StartScreen {
	constructor(game) {
		this.game = game;
		this.screen = document.getElementById('start-screen');
		this.btnPlay = document.getElementById('play');

		this.btnPlay.addEventListener('click', this.hide.bind(this));
	}

	hide() {
		gsap.to(this.screen, {
			duration: 0.3,
			opacity: 0,
			autoAlpha: 0,
			onComplete: () => {
				this.game.start = true;
			},
		});

		// analytics
		// eslint-disable-next-line no-undef
		gtag('event', 'game_start');
	}
}
